// extracted by mini-css-extract-plugin
module.exports = {"isNotify":"App_isNotify__okGYe","mainContainer":"App_mainContainer__1sMY1"};